import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useOrgData } from "@/hooks/useOrgData";
import MatrixTable from "@/components/MatrixTable";
import ReminderPanel from "@/components/ReminderPanel";
import WorkerSheet from "@/components/WorkerSheet";
import ImportDialog from "@/components/ImportDialog";
import WorkerFormDialog from "@/components/WorkerFormDialog";
import { Upload, UserPlus } from "lucide-react";

export default function Trabajadores({ search, setSearch }) {
  const { user } = useAuth();
  const { workers, requirements, projects, positions, mandantes, reload } = useOrgData();
  const [selected, setSelected] = useState([]);
  const [reminderIds, setReminderIds] = useState(null);
  const [openWorker, setOpenWorker] = useState(null);
  const [importOpen, setImportOpen] = useState(false);
  const [formOpen, setFormOpen] = useState(false);
  const canEdit = user?.role !== "VIEWER";
  const canCreate = ["ADMIN", "HR_MANAGER", "RECRUITER"].includes(user?.role);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-display text-3xl font-bold text-slate-900">Trabajadores</h1>
          <p className="text-slate-500 mt-1">{workers.length} trabajadores en seguimiento.</p>
        </div>
        {canCreate && (
          <div className="flex gap-2">
            <button data-testid="import-excel-button" onClick={() => setImportOpen(true)} className="inline-flex items-center gap-2 bg-white border border-slate-200 hover:bg-slate-50 text-slate-700 text-sm font-medium px-4 py-2.5 rounded-lg">
              <Upload size={16} /> Importar Excel
            </button>
            <button data-testid="add-worker-button" onClick={() => setFormOpen(true)} className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-4 py-2.5 rounded-lg">
              <UserPlus size={16} /> Nuevo trabajador
            </button>
          </div>
        )}
      </div>

      <MatrixTable
        requirements={requirements} workers={workers} projects={projects} positions={positions} mandantes={mandantes}
        selected={selected} setSelected={setSelected}
        onReload={reload} onOpenWorker={setOpenWorker}
        onSend={(ids) => setReminderIds(ids)}
        canEdit={canEdit} search={search} setSearch={setSearch}
      />

      <ReminderPanel open={!!reminderIds} workerIds={reminderIds || []} onClose={() => setReminderIds(null)} onSent={() => { reload(); setSelected([]); }} />
      <WorkerSheet workerId={openWorker} open={!!openWorker} onClose={() => setOpenWorker(null)} canEdit={canEdit} onChanged={reload} />
      <ImportDialog open={importOpen} onClose={() => setImportOpen(false)} onDone={reload} />
      <WorkerFormDialog open={formOpen} onClose={() => setFormOpen(false)} projects={projects} onDone={reload} />
    </div>
  );
}
